import React from "react"

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

import DiaryEntriesList from "./DiaryEntriesList"
import UsersSubmittingDiaryEntriesTab from "./UsersSubmittingDiaryEntriesTab"

const DiaryEntriesOverviewTab: React.FC = () => {
  return (
    <Tabs defaultValue="outstanding" className="w-full h-full">
      <TabsList className="mb-4">
        <TabsTrigger value="outstanding">Outstanding Entries</TabsTrigger>
        <TabsTrigger value="users-submitting">Users Submitting</TabsTrigger>
        <TabsTrigger value="all">All Entries</TabsTrigger>
      </TabsList>
      <TabsContent value="outstanding" className="h-full">
        <DiaryEntriesList />
      </TabsContent>
      <TabsContent value="users-submitting" className="h-full">
        <UsersSubmittingDiaryEntriesTab />
      </TabsContent>
      <TabsContent value="all" className="h-full">
        <DiaryEntriesList showOnlyOutstanding={false} />
      </TabsContent>
    </Tabs>
  )
}

export default DiaryEntriesOverviewTab
